// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PeQW","question":"styles_question__1SiiW","description":"styles_description__2Uz8I"};